import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { selectLocalUserId } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';
import { requestRestreaming } from 'features/restreamer/actions';

export function* requestRestreamingSaga(action: ReturnType<typeof requestRestreaming>) {
  const userId: UserId = yield select(selectLocalUserId);
  logger.remote({ tier: 1 }).info(`Restreaming initiated by user: ${userId}`);

  yield call(SignalingSocket.send, {
    event: 'requestRestreaming',
    data: action.payload,
  });
}
